<!--
 * @Author: Tahiti
 * @Date: 2025-11-06 23:30:41
 * @LastEditors: Tahiti
 * @LastEditTime: 2025-12-31 15:18:13
 * @Description: 视频播放器组件，支持 SEO 结构化数据
 * @FilePath: /weryai-web/components/VideoPlayer.vue
-->
<template>
    <div class="video-container">
        <video
            class="feature-video-player"
            preload="metadata"
            :poster="poster"
            crossorigin="anonymous"
            playsinline
            autoplay
            loop
            muted
            webkit-playsinline
        >
            <source :src="src" type="video/mp4" />
            {{ fallbackText || 'Your browser does not support video playback' }}
        </video>
    </div>
</template>

<script setup lang="ts">
interface Props {
    src: string
    poster?: string
    fallbackText?: string
    /** 视频标题（用于 SEO VideoObject 结构化数据） */
    title?: string
    /** 视频描述（用于 SEO VideoObject 结构化数据） */
    description?: string
    /** 视频上传日期（ISO 8601 格式，如 '2025-10-20T00:00:00+08:00'） */
    uploadDate?: string
}

const props = defineProps<Props>()

// 当同时提供 title + poster 时，自动注入 VideoObject 结构化数据
if (props.title && props.poster) {
    useHead({
        script: [
            {
                key: `videoobject-schema:${props.src}`,
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'VideoObject',
                    name: props.title,
                    description: props.description || props.title,
                    contentUrl: props.src,
                    thumbnailUrl: props.poster,
                    // uploadDate 必须包含时区信息（ISO 8601 格式）
                    uploadDate: props.uploadDate || '2025-10-20T00:00:00+08:00',
                    // 自托管视频的额外属性
                    encodingFormat: 'video/mp4',
                }),
            },
        ],
    })
}
</script>

<style lang="less" scoped>
.video-container {
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    border-radius: 1rem;
    overflow: hidden;
    background: rgba(0, 0, 0, 0.3);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.feature-video-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
}
</style>
